function PageHeadline(props) {
	return (
		<div className="PageHeadline">
			<div className="name">{props.title}</div>
		</div>
		)
}

export default PageHeadline